export default function () {
  return {
    queueList: [],
    isParallelQueuesUsed: true,
    isSocketDisconnected: false,
    isOffline: false,
    socket: null,
    isMaintenanced: false,
    accessToken: '',
    refreshToken: '',
    restaurant: { // 매장 정보
      timeOutSec: 50,
      foreignRequestType: [], // 외국인 입력 정보 배열
      idx: -1,
      name: '',
      notice: {
        basic: '',
        confirm: ''
      },
      message: '',
      basicNoti: '',
      confirmNoti: '',
      status: 'PRIVATE',
      nameRequired: true,
      phoneRequired: false,
      useLimitForWaiting: false, // 대기 건당 인원제한 사용 여부
      maxPeople: 0,
      menuRequired: false,
      isPhoneNumber: false, // 전화번호 미입력 하용 여부(DB에 직접 설정)
      isNumTicket: false, // 번호표 사용 여부(DB에 직접 설정)
      useWaitingConfirmCode: false, // 대기 확정코드 사용 여부
      childMenuOrderType: 'EXCLUDE', // 메뉴 주문시 유아 인원 포함 여부 EXCLUDE | RANGE | INCLUDE
      useOnePersonOneMenuOrder: false, // 1인 1메뉴
      useWaitingQueue: false, // 대기열 세분화 사용 여부
      usePersonnelTypes: false, // 인원 유형 사용 여부 (TB-14763)
      personnelTypes: [] // 인원 유형 설정값 [{ name, description, isChild, multiLanguage }]
    },
    otpNumber: 0, // 대기 확정 코드
    locale: 'ko', // 언어 설정 정보(ko, en, jp, cn_simplified)
    waitingCount: 0, // 대기 팀 수
    waitingCountChange: false, // 대기 팀 수 변경
    restaurantInfoChange: false, // 매장 정보 변경
    menuInfoChange: false, // 메뉴 정보 변경
    waitingParams: { // 대기등록 정보
      queueName: '', // 대기열 세분화 사용시 대기열명
      queueNameMultiLanguage: {}, // 대기열명 다국어 정보 { en: '', ja: '', zh-CN: '' }
      queueIndex: -1, // 대기열 idx 대기열 세분화 사용하지 않을경우 -1
      name: '',
      phoneNumber: '',
      numOfPeople: 1,
      childCount: 0,
      personnelTypes: [], // 인원 유형별 선택 인원 [{ name, description, isChild, multiLanguage, count }] (TB-14763)
      memo: '',
      source: 'KIOSK',
      isAgreement: false,
      isMarketing: false,
      isThirdParty: false, // 현재 사용하지 않음
      isNoPhone: false,
      menus: new Map(),
      email: '',
      tempKey: '' // LINE 접수 시 발급받은 임시키(서버가 LINE 유저 ID 조회에 사용)
    },
    receivedLineTempKey: '', // 소켓으로 수신한 LINE 인증 완료 임시키
    selectedClientRequest: new Map(), // 선택된 고객 요청사항 map
    clientRequestList: [], // 사장님 보드에서 설정한 고객 요청사항 목록
    requestFailure: false,
    restaurantMenuInfo: {}
  }
}
